<template>
  <div class="data-import">
    <Alert type="warning" show-icon>
      数据导入时间可能较长，请耐心等待，导入期间可以关闭进行其它操作，导入完毕后会提示你！
    </Alert>
    <Alert type="success" show-icon closable style="margin: 16px 0;" @on-close="successAlert = false" v-if="successAlert">{{ successFileName }}导入成功啦！</Alert>
    <Upload
      type="drag"
      ref="upload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
      :show-upload-list="false"
      :format="format"
      :max-size="maxSize"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :action="uploadUrl">
      <div style="padding: 20px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #1e88e5"></Icon>
        <p>点击或拖拽文件到这里来上传</p>
      </div>
    </Upload>
    <div v-if="importFile !== null" style="margin: 16px 0;">
      <p>{{ importFile.name }} <Icon type="md-close" v-if="!uploadingFile" @click.native="handleRemove" style="font-size:15px;margin-left: 20px;cursor: pointer;"></Icon></p>
      <template v-if="uploadingFile && uploadingFile.status === 'uploading'">
        <Progress v-if="uploadingFile.showProgress" :percent="uploadingFile.percentage" :stroke-width="3" hide-info></Progress>
      </template>
    </div>
    <p style="font-size:0.9em; opacity: 0.7; margin: 16px 0;">仅支持上传单个json格式的文件，文件小于{{ maxSizeText }}。</p>
    <Button type="primary" :loading="loading" @click="importList" long>{{ loading ? '上传处理中...' : '开始上传处理' }}</Button>
  </div>
</template>

<script>
import { UPLOAD_URL } from '../../config/constants'

export default {
  name: 'DataImport',
  data () {
    return {
      format: ['json'],
      maxSize: 1024 * 100, // 100M
      uploadUrl: UPLOAD_URL,
      loading: false,
      importFile: null,
      successAlert: false,
      successFileName: ''
    }
  },
  computed: {
    maxSizeText () {
      return this.maxSize / 1024 + 'M'
    },
    uploadingFile () {
      return this.$refs.upload.fileList[0]
    }
  },
  methods: {
    handleBeforeUpload (file) {
      this.importFile = file
      return false
    },
    handleSuccess (res, file) {
      if (file.response.code !== 200) {
        this.$Message.error(file.response.message || '上传文件错误，请重新上传！')
        this.handleList()
      } else {
        this.successFileName = file.name
        this.successAlert = true
        this.handleList()
        this.handleRemove()
        this.$Notice.success({
          title: '数据导入成功',
          desc: '数据已导入成功并处理完毕，你可以查询最新的统计数据啦！'
        })
      }
    },
    // eslint-disable-next-line handle-callback-err
    handleError (error, file, fileList) {
      this.$Message.error('上传发生错误，请稍后重试！')
      this.handleList()
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '文件格式错误',
        desc: '文件：' + file.name + ' 的格式不正确，请重新选择！'
      })
      this.handleList()
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: '文件超过大小限制',
        desc: file.name + '超过' + this.maxSizeText + '大小的限制。'
      })
      this.handleList()
    },
    handleList () {
      this.loading = false
      this.$refs.upload.fileList = []
    },
    handleRemove () {
      this.importFile = null
      this.$refs.upload.fileList = []
    },
    importList () {
      if (!this.importFile) {
        this.$Notice.warning({
          title: '提示',
          desc: '请先选择上传文件'
        })
        return
      }
      this.loading = true
      this.successAlert = false
      this.$refs.upload.post(this.importFile)
    }
  }
}
</script>

<style lang="less">

</style>
